import ExpertInfoController, {type ExpertsResponse} from "../../preprocess/lib/ExpertInfoController";

function applyStarsResponseToPage(response: ExpertsResponse) {
	for (let [postId, ratingInfo] of Object.entries(response)) {
		for (const display of document.querySelectorAll(`.wp-block-plaudit-star-rating-display[data-post-id="${postId}"]:not(.set-up)`)) {
			display.classList.toggle('set-up', true);
			if (display.hasAttribute("data-rating")) {
				ratingInfo = {
					rating: display.getAttribute("data-rating")!, roundedRating: display.getAttribute("data-rounded-rating")!,
					"survey-count": 0, specialties: ""
				}
            } else {
                display.setAttribute("data-rating", ratingInfo.rating.toString());
                display.setAttribute("data-rounded-rating", ratingInfo.roundedRating);
            }
			const ratingDescription = display.querySelector(".rating-description");
			if (ratingDescription) {
				const surveyInfo = display.getAttribute("data-include-survey-info") === "true"
					? ` based on ${ratingInfo["survey-count"]} Surveys*` : "";
				ratingDescription.ariaLabel = `Rated ${ratingInfo.rating} out of 5 Stars${surveyInfo}`;
				ratingDescription.innerHTML = `(${ratingInfo.rating})${surveyInfo}`;
			}
		}
	}
}
function updateAllStarRatings() {
	return ExpertInfoController.callWithExpertData(applyStarsResponseToPage);
}
document.addEventListener('DOMContentLoaded', () => {
	updateAllStarRatings().then(() => {
		new MutationObserver(() => updateAllStarRatings())
			.observe(document, {childList: true, subtree: true});
	});
});
